import { useCallback } from "react";
import { useIsDarkTheme } from "@/components/layout/useIsDarkTheme";

export const useRpmPerState = () => {
  const isDarkTheme = useIsDarkTheme();

  const getColor = useCallback(
    (value, nationalAverageRPM) => {
      if (value === 0) return isDarkTheme ? "#272F2C" : "#D9E3DE";
      if (value > nationalAverageRPM * 1.2) return isDarkTheme ? "#24B98C" : "#43BC98";
      if (value > nationalAverageRPM * 1.05) return isDarkTheme ? "#228566" : "#79CDB2";
      if (value > nationalAverageRPM * 0.8 && value < nationalAverageRPM * 1.05) return isDarkTheme ? "#21644D" : "#A8DDC9";
      if (value < nationalAverageRPM * 0.8) return isDarkTheme ? "#1E382E" : "#D9EDE4";
      return isDarkTheme ? "#000" : "#fff";
    },
    [isDarkTheme],
  );

  const getIndexColor = useCallback(
    (index, outboundsLength) => {
      if (index === undefined) return isDarkTheme ? "#272F2C" : "#D9E3DE";
      if (index === 0 || index / outboundsLength < 0.1) return isDarkTheme ? "#24B98C" : "#43BC98";
      if (index / outboundsLength < 0.3) return isDarkTheme ? "#228566" : "#79CDB2";
      if (index / outboundsLength < 0.65) return isDarkTheme ? "#21644D" : "#A8DDC9";
      return isDarkTheme ? "#1E382E" : "#D9EDE4";
    },
    [isDarkTheme],
  );

  return { getColor, getIndexColor };
};
